var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrows(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 39.811,
    height: 28.196,
    viewBox: "0 0 39.811 28.196",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1812.949 -2695.726) rotate(90)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2714.466,1802.058c0-2.7.02-5.414-.011-8.121-.007-.745.2-.962.8-.952,1.992.04,3.983,0,5.973.021a2.4,2.4,0,0,0,2.487-1.659,3.462,3.462,0,0,0-.74-3.494q-5.577-6.76-11.166-13.51c-1.334-1.609-2.659-1.606-3.992,0q-5.559,6.717-11.106,13.446a3.335,3.335,0,0,0-.453,4.158,2.264,2.264,0,0,0,2.1,1.049c1.993.006,3.983.034,5.973-.014.654-.016.835.231.833,1.01-.027,5.118-.016,10.236-.009,15.353a10.2,10.2,0,0,0,.088,1.377c.159,1.188.709,2.032,1.672,2.1a39.1,39.1,0,0,0,5.624.047c1.319-.1,1.909-1.137,1.915-2.783C2714.474,1807.409,2714.466,1804.734,2714.466,1802.058Z",
    fill: "#bebebe",
    fillRule: "evenodd"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrows);
export default __webpack_public_path__ + "static/media/arrows.2f9e56cf.svg";
export { ForwardRef as ReactComponent };